import { AxDropdown } from "@axess/limestone";
import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { CompPackBookingValues } from "../../Models/ComplexPackages/BookingOptions/CompPackBookingValues";
import { BookingTimeSlotInfo } from "../../Models/ComplexPackages/BookingTimeSlotInfo";
import { CompPackBookingPersonOptions } from "./BookingOptions/CompPackBookingPersonOptions";
import { ComplexPackageBookingTicketsOptions } from "./BookingOptions/ComplexPackageBookingTicketsOptions";

@ModuleName("ComplexPackageBookingOptions")
export class ComplexPackageBookingOptions implements AxInit {
    dropDowns = new Array<AxDropdown>();
    bookingValues: CompPackBookingValues;

    private axLoading: AxLoading;
    private i18NHelper: I18nHelper;
    private shoppingCartUrl: string;

    AxInit(init: initData): void {
        this.axLoading = new AxLoading();
        this.i18NHelper = new I18nHelper();
        this.shoppingCartUrl = init.shoppingCartUrl;

        // object for addToCart
        this.bookingValues = new CompPackBookingValues(init.projNr, init.packageId, init.tariffSheetId, init.startSoapDate, init.endSoapDate);

        $('#compPackAddToCartBtn').on('click', () => this.addToCart(this.bookingValues));
    }

    getDropDownBySelector(selector: string): AxDropdown {
        return this.dropDowns.find((i) => i.getSelector() === selector);
    }

    validateInputs() {
        const bookingModule = AxLoad.GetModule<ComplexPackageBookingTicketsOptions>("ComplexPackageBookingTicketsOptions");
        const $personDropdown = this.getDropDownBySelector('.prod_selection__person-selection .ax-dropdown');
        const $lessonOptionHolder = $(document).find('#lessonOptionsHolder');
        const $lessonProgramDropdown = this.getDropDownBySelector('.prod_selection__lessonProgramSlot-selection .ax-dropdown');
        const isLesson = $('#lessonOptionsHolder').children().length > 0 && $('#optionTimeslotSelectButton').length > 0;
        const isRentalOptionsHolder = $('#rentalOptionsHolder').length > 0;
        const $skillLevelPillHolder = $('.compPack_User_SkillLevel_pillHolder');
        const $genderDropdown = this.getDropDownBySelector('.prod_selection__gender-selection .ax-dropdown');
        const $heightDropdown = this.getDropDownBySelector('.prod_selection__height-selection .ax-dropdown');
        const $weightDropdown = this.getDropDownBySelector('.prod_selection__weight-selection .ax-dropdown');
        const $shoeSizeDropdown = this.getDropDownBySelector('.prod_selection__shoeSize-selection .ax-dropdown');
        let valid: boolean = true;

        // person select
        if (!$personDropdown || !$personDropdown.validate()) {
            valid = false;
        }

        // Timeslots ticket
        this.bookingValues?.ticketOrderValues?.forEach((ticket) => {
            const elementName = `#compPack_products_ticket_holder_${ticket.projNr}_${ticket.poolNr}_${ticket.ticketTypeNr}`;
            const $element = $(elementName);

            const bookingRequiredList: BookingTimeSlotInfo = bookingModule.bookingTimeSlotInfos.find((timeSlot) => (
                timeSlot.packagePositionNr === ticket.packagePositionNr
            ));

            if (bookingRequiredList && ticket.selectedTimeSlots?.length !== bookingRequiredList.requiredTimeSlots?.length) {
                $element.addClass('ax-form-group invalid-form');
                valid = false;
                this.jumpToSelector(elementName);
            } else {
                $element.removeClass('ax-form-group invalid-form');
            }
        });

        if ($lessonOptionHolder.length > 0 && $lessonProgramDropdown && this.bookingValues.lessonProgramOrderValues?.length == 0) {
            valid = false;
            this.jumpToSelector('.prod_selection__lessonProgramSlot-selection .ax-dropdown');
        }

        if ($('[data-cp-lessons="out"]').length > 0) {
            valid = false;
        }
         
        // timeslots lesson
        if (isLesson) {
            const $timeSlotSelectButton = $('#optionTimeslotSelectButton');
            const isTimeSlotSelected = $timeSlotSelectButton.find('span.ax-dropdown__selection').text().length > 0;
            valid = valid && isTimeSlotSelected;
        }

        // rental pills
        if (isRentalOptionsHolder && !this.bookingValues.skillLevel) {
            $skillLevelPillHolder.addClass('ax-form-group invalid-form');
            valid = false;
            this.jumpToSelector('#rentalOptionsHolder');
        } else {
            $skillLevelPillHolder.removeClass('ax-form-group invalid-form');
        }

        // rental dropdowns
        if ($genderDropdown && !$genderDropdown?.validate()) {
            valid = false;
            this.jumpToSelector('.prod_selection__gender-selection .ax-dropdown');
        }

        if ($heightDropdown && !$heightDropdown.validate()) {
            valid = false;
            this.jumpToSelector('.prod_selection__height-selection .ax-dropdown');
        }

        if ($weightDropdown && !$weightDropdown?.validate()) {
            valid = false;
            this.jumpToSelector('.prod_selection__weight-selection .ax-dropdown');
        }

        if ($shoeSizeDropdown && !$shoeSizeDropdown.validate()) {
            valid = false;
            this.jumpToSelector('.prod_selection__shoeSize-selection .ax-dropdown');
        }

        return valid;
    }

    jumpToSelector(selector: string) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $(selector).offset()?.top - 100
        }, 100);
    }

    addToCart(bookingValues: CompPackBookingValues) {
        if (!this.validateInputs()) {
            return;
        }

        const personModule = AxLoad.GetModule<CompPackBookingPersonOptions>("CompPackBookingPersonOptions");
        personModule.setLessonPropsToBookingOptions();

        this.axLoading.ShowLoadingIndicatorFixed($('.compPack_bookingOptions_body')?.get(0));

        bookingValues.ticketOrderValues.forEach((ticketEntry) => {
            ticketEntry.timeSlotKeys = ticketEntry?.selectedTimeSlots?.map((timeSlot) => timeSlot.timeSlotKey) || [];
        });

        const data = JSON.parse(JSON.stringify(bookingValues || {}) || '{}');
        AxessViewer.loadPartialView('/ComplexPackagesBooking/AddComplexPackageToCart', data, (result: any) => {
            const comPackBookingResult: ComPackBookingResult = JSON.parse(result || '{}');

            if (!comPackBookingResult.success) {
                this.axLoading.HideLoadingIndicator($('.compPack_bookingOptions_body')?.get(0));
                Swal.fire({
                    title: this.i18NHelper.GetTranslation(Translations.Error),
                    icon: 'warning',
                    html: comPackBookingResult.errorMsg,
                });
            } else {
                AxLoad.LoadModule('AxGA4Module', {
                    caller: 'Add to Cart',
                    event: 'Add to Cart',
                }).then(() => window.location.href = this.shoppingCartUrl);
            }
        }, {
            dataType: 'html',
        });
    }
}

class ComPackBookingResult {
    success: boolean;
    errorMsg: string;
}

export interface initData {
    projNr: number;
    packageId: number;
    tariffSheetId: number;
    startSoapDate: string;
    endSoapDate: string;
    shoppingCartUrl: string;
    lessonOrderValues: string;
}
